/*
 **********************************************************************************************
 *@license
 * Copyright (c) 2015-2025 Future Intelligence Technology Solutions Limited, United Kingdom.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 **********************************************************************************************
 */

'use strict';

import './fi-01-PD-Index.html'; // it will invoke html-loard


import './fi-01-PD-app.scss';


import {
  MDCTopAppBar
} from '@material/top-app-bar';

// app bar Instantiation
const topAppBarElement = document.querySelector('.mdc-top-app-bar');
const topAppBar = new MDCTopAppBar(topAppBarElement);

//instantiation : ripple effect to all fab buttons and buttons
import {
  MDCRipple
} from '@material/ripple';

const fabsRipple = document.querySelectorAll('.mdc-fab'); // for all fabs - ripple effect
for (const fab of fabsRipple) {
  MDCRipple.attachTo(fab);
}

const buttonsRipple = document.querySelectorAll('.mdc-button'); // for all fabs - ripple effect
for (const button of buttonsRipple) {
  MDCRipple.attachTo(button);
}

//list related - for keyboard interaction
import {
  MDCList
} from '@material/list';

//const list = new MDCList(document.querySelector('.mdc-list')); // need to check how to do this for all list using one command block

const listsRipple = document.querySelectorAll('.mdc-list'); // for all list - ripple effect
for (const list of listsRipple) {
  MDCRipple.attachTo(list);
}


//card related 
/*const cardSelector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
const cardRipples = [].map.call(document.querySelectorAll(cardSelector), function(el) {
  return new MDCRipple(el);
});
*/
// for tabs
/*import {MDCTabBar} from '@material/tab-bar';

const tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'));

import {MDCTabScroller} from '@material/tab-scroller';

const tabScroller = new MDCTabScroller(document.querySelector('.mdc-tab-scroller'));

import {MDCTab} from '@material/tab';

const tab = new MDCTab(document.querySelector('.mdc-tab'));

import {MDCTabIndicator} from '@material/tab-indicator';

const tabIndicator = new MDCTabIndicator(document.querySelector('.mdc-tab-indicator'));
*/

// text field

import {
  MDCTextField
} from '@material/textfield';

//const textField = new MDCTextField(document.querySelector('.mdc-text-field'));

const [textFields, textFieldRipples] = [].map.call(document.querySelectorAll('.mdc-text-field'), function (el) {
  return [new MDCTextField(el), new MDCRipple(el)];
});

/*const textFieldRipples = [].map.call(document.querySelectorAll('.mdc-text-field'), function(el) {
  return new MDCRipple(el);
}); */


import {
  MDCFloatingLabel
} from '@material/floating-label';

const floatingLabels = [].map.call(document.querySelectorAll('.mdc-floating-label'), function (el2) {
  return new MDCFloatingLabel(el2);
});

/*import {MDCTextFieldCharacterCounter} from '@material/textfield/character-counter';

const characterCounters = [].map.call(document.querySelectorAll('.mdc-text-field-character-counter'), function(el3) {
  return new MDCTextFieldCharacterCounter(el3);
});

*/
//const characterCounter = new MDCTextFieldCharacterCounter(document.querySelector('.mdc-text-field-character-counter'));

const currentPageBody = document.body;

if (currentPageBody.id == "fi-services-view") {
  console.log('inside page :' + currentPageBody.title);
} else {
  console.log('Not inside page :' + currentPageBody.title);
}
import {
  MDCFormField
} from '@material/form-field';
import {
  MDCCheckbox
} from '@material/checkbox';

// check box related
//if (currentPageBody.title=="fi-contactus-view") {}
/*
  const checkBoxes = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
  const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
  formField.input = checkBoxes;
  console.log("hello");
  console.log("message from formField :"+ formField.input.checked);
  console.log("message from checkBoxes :"+ checkBoxes.checked);

  const cbEl = document.querySelector('.mdc-checkbox');
  var checkbx = document.querySelector('.mdc-checkbox input');//Find your checkbox input

  checkbx.addEventListener('click', () => {
      console.log(checkbx.checked); //will return true or false
  });
*/

/*formField.addEventListener('click', () => {
  console.log("hello2");
  console.log(checkBoxes.checked); //will return true or false
}, false);*/
/* testing code
var comments = document.getElementsByClassName('button');
var numComments = comments.length;
function showComment(e) {
  var place = document.querySelector('#textfield1');
  var commentBox = document.createElement('textarea');
  place.appendChild(commentBox);
  commentBox.value="this is fun!!!";
  for (var i = 0; i < numComments; i++) {
    comments[i].removeEventListener('click', showComment, false);
  }
}
for (var i = 0; i < numComments; i++) {
  comments[i].addEventListener('click', showComment, false);
}
*/
// code for submit and cancel buttons
// code for btnSubmitId submit "send message"
import {
  fiContactus
} from './fi-01-PD-contact-script.js';
import {
  MDCSwitch
} from '@material/switch';

if (currentPageBody.id == "fi-services-view") {
  const sbt = document.getElementById('fi-btnSubmitId');
  sbt.addEventListener("click", fiContactus);

  // mdc card related
  //import {MDCRipple} from '@material/ripple';

  const cardItems = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
  const cardItemRipples = [].map.call(document.querySelectorAll(cardItems), function (carditem) {
    return new MDCRipple(carditem);
  });

  const flipCards = document.querySelectorAll('.fi-flip-card-inner');
  for (const flipCard of flipCards) {
    flipCard.addEventListener('click', function () {
      flipCard.classList.toggle('is-flipped');
    });
  }



  /*for switch */
  //    import {MDCSwitch} from '@material/switch';

  const switchControls = [].map.call(document.querySelectorAll('.mdc-switch'), function (el3) {
    return new MDCSwitch(el3);
  });




  /* type-writing effect */

  // set up text to print, each item in array is new line

  var aText = new Array(
    "There are only 10 types of people in the world:",
    "Those who understand binary, and those who don't"
  );
  var iSpeed = 100; // time delay of print out
  var iIndex = 0; // start printing array at this posision
  var iArrLength = aText[0].length; // the length of the text array
  var iScrollAt = 20; // start scrolling up at this many lines

  var iTextPos = 0; // initialise text position
  var sContents = ''; // initialise contents variable
  var iRow; // initialise current row

  function typewriter() {
    sContents = ' ';
    iRow = Math.max(0, iIndex - iScrollAt);
    var destination = document.getElementById("typedtext");

    while (iRow < iIndex) {
      sContents += aText[iRow++] + '<br />';
    }
    destination.innerHTML = sContents + aText[iIndex].substring(0, iTextPos) + "_";
    if (iTextPos++ == iArrLength) {
      iTextPos = 0;
      iIndex++;
      if (iIndex != aText.length) {
        iArrLength = aText[iIndex].length;
        setTimeout("typewriter()", 500);
      }
    } else {
      setTimeout("typewriter()", iSpeed);
    }
  }


  //typewriter();
  /* end of typewriter function */
  const acbt = document.getElementById('fi-cookie-message-buttons-accept-id');
  acbt.addEventListener("click", hideCookieSection);

  const dcbt = document.getElementById('fi-cookie-message-buttons-decline-id');
  dcbt.addEventListener("click", hideCookieSection);



} /* end of if block "fi-services-view" */

function hideCookieSection() {
  /* Internal function invoked by event handler only */
  var y = document.getElementById("fi-cookie-section-id");
  //y.visibility = hidden;
  y.style.display = 'none';
  //y.visibility = 'hidden';
}

///////////////////////
import './fi-01-PD-legal.html'; // it will invoke html-loard for legal :added on 10-Sep-2022

// for Carbon Reduction Plan pdf files download links
import fi_pdf_crp_01 from "./docs/Fuinteso-CarbonReductionPlan-2021-signed.pdf";
// const PDF = require("./assets/file.pdf");
// const TXT = require("./assets/file.txt");
document.getElementById("fi-carbon-red-plan-id-01").href = fi_pdf_crp_01;

// for legal year duration and last update date 8=September, 9=October

var curDt = new Date();
var curYr = curDt.getFullYear();
var curMn = curDt.getMonth();

// for legal year duration and last update date 8=September, 9=October

var curYrDu = (curMn < 9) ? (curYr - 1).toString() + ' - ' + curYr.toString() : curYr.toString() + ' - ' + (curYr + 1).toString();
var upDt = (curMn < 9) ? "21-Sep-" + (curYr - 1).toString() : "21-Sep-" + curYr.toString();

var fiElements = document.getElementsByClassName("fi-cls-year-span");
for (var i = 0; i < fiElements.length; i++) {
  fiElements[i].innerHTML = curYrDu;
}

var fiElements2 = document.getElementsByClassName("fi-cls-update-date");
for (var i = 0; i < fiElements2.length; i++) {
  fiElements2[i].innerHTML = upDt;
}

// for Modern Slavery Review and Approval; 8=September, 9=October
var fiReviewDate = (curMn < 9) ? "31st August " + (curYr - 1).toString() : "31st August " + curYr.toString();
var fiApprovedDate = (curMn < 9) ? "11th September " + (curYr - 1).toString() : "11th September " + curYr.toString();

document.getElementById("fi-mss-review-dt").innerHTML = fiReviewDate;
document.getElementById("fi-mss-approved-dt").innerHTML = fiApprovedDate;




///////////////////////